import React from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import AssetRegistry from "./AssetRegistry";
import { REGISTRY_DEFS } from "./registrySchemas";

/** Single route page that resolves the registry definition by URL param. */
const SLUG_TO_KIND = {
  "pressure-sensors": "pressure_sensor",
  "tanks": "tank",
  "valves": "valve",
  "lifts": "lift",
  "fans": "fan",
  "fire-alarm-devices": "fire_alarm_device",
  "mcc-panels": "mcc_panel",
};

export default function RegistryRoute() {
  const { kind: slug } = useParams();
  const kind = SLUG_TO_KIND[slug] || slug;
  const def = REGISTRY_DEFS[kind];
  if (!def) return <Navigate to="/registry/pressure-sensors" replace />;
  return <AssetRegistry assetType={kind} title={def.title} icon={def.icon} accentColor={def.accentColor} schema={def.schema} />;
}
